import React from 'react';
import { useTranslation } from 'react-i18next';
import useAppContext from '../../../../context/useAppContext';
import { useSegment } from '../../../../components/tracking/trackingProvider';
import { Dropdown } from '@weezevent/nacre';
import PropTypes from 'prop-types';
import GroupModal from '../../groupModal';

export function NewGroupAction({ groups, model, onSave }) {
    const [showModal, setShowModal] = React.useState(false);
    const { t } = useTranslation();
    const { track } = useSegment();
    const [{ event }] = useAppContext();

    return (
        <React.Fragment>
            {showModal && (
                <GroupModal
                    groups={groups}
                    event={event}
                    showModal={showModal}
                    onClose={() => setShowModal(false)}
                    onAccept={() => {
                        setShowModal(false);
                        onSave();
                    }}
                    GroupClass={model}
                />
            )}
            <Dropdown.Item
                onClick={() => {
                    setShowModal(true);
                    track('ACTION > ADD GROUP', { 'Page Title': 'TICKET TYPES' });
                }}
            >
                {t('ticket.rates.addGroup')}
            </Dropdown.Item>
        </React.Fragment>
    );
}

NewGroupAction.propTypes = {
    groups: PropTypes.array.isRequired,
    model: PropTypes.func,
    onSave: PropTypes.func.isRequired
};
